import React, { useState } from "react";
import { EnhancedSections } from "../components/enhanced-sections";
import { UserLangCode } from "src/utils/util.types";
import { Role } from "src/entities/user.entity";
import { FaArrowUp } from "react-icons/fa";

export type TimePeriod = "day" | "week" | "month" | "year" | "absolute";
export type EnhancedFilterState = {
  langCode?: UserLangCode;
  role: Role | "ALL" | "DUAL";
  timePeriod: TimePeriod;
  startDate?: Date;
  endDate?: Date;
  timeZone?: string;
};

export default function EnhancedDashboard() {
  const [filters, setFilters] = useState<EnhancedFilterState>({
    role: "ALL",
    timePeriod: "month",
  });
  const [showScrollTop, setShowScrollTop] = useState(false);

  const handleFilterChange = (newFilters: Partial<EnhancedFilterState>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  React.useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="min-h-screen p-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Graphical Statistics</h1>
          <p className="text-gray-600">
            Advanced analytics interface with role-based filtering and time period analysis
          </p>
        </div>

        <EnhancedSections filters={filters} />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-emerald-600 hover:bg-emerald-700 text-white p-1.5 rounded-full shadow-2xl ring-4 ring-amber-300/80 ring-offset-2 ring-offset-white transition-all duration-300 z-50 group"
          aria-label="Scroll to top"
        >
          <div className="flex items-center justify-center rounded-full border-2 border-amber-100/80 px-3 py-3">
            <FaArrowUp className="text-xl group-hover:-translate-y-1 transition-transform duration-300" />
          </div>
        </button>
      )}
    </div>
  );
}
